import useThemeStore from "../store/useThemeStore";

export const WLJ_THEME_CHANGE_EVENT = "wlj-theme-change";

/** True only for boolean true or the stored string "true". */
export function isAppDark(value) {
  return value === true || value === "true";
}

export function readStoredDarkMode() {
  if (typeof window === "undefined") return false;
  return isAppDark(window.localStorage.getItem("isDark"));
}

export function readDomDarkMode() {
  if (typeof document === "undefined") return false;
  return document.documentElement.getAttribute("data-theme") === "dark";
}

/**
 * Apply light/dark to html + body + store + localStorage in one step.
 * This is the only writer. Do not also keep a separate useLocalStorage copy.
 */
export function applyTheme(isDark) {
  if (typeof document === "undefined") return isAppDark(isDark);

  const dark = isAppDark(isDark);
  const theme = dark ? "dark" : "light";
  const html = document.documentElement;

  html.setAttribute("data-theme", theme);
  html.setAttribute("data-bs-theme", theme);
  html.style.colorScheme = theme;

  document.body.classList.toggle("darkMode", dark);
  document.body.classList.toggle("lightMode", !dark);

  if (typeof window !== "undefined") {
    window.localStorage.setItem("isDark", JSON.stringify(dark));
  }

  useThemeStore.getState().setIsDark(dark);
  return dark;
}

export function dispatchThemeChange(isDark) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(WLJ_THEME_CHANGE_EVENT, {
      detail: { isDark: isAppDark(isDark) },
    })
  );
}

/** Flip from the live store (what the switch shows), never a stale prop. */
export function toggleAppTheme() {
  const current = useThemeStore.getState().isDark === true;
  const next = !current;
  applyTheme(next);
  dispatchThemeChange(next);
  return next;
}

export function beginForcedLightTheme() {
  const prevDark = readDomDarkMode();
  applyTheme(false);
  return prevDark;
}

export function endForcedLightTheme(prevDark) {
  applyTheme(prevDark);
}
